const COLLAPSIBLE_LIST_TYPE = "wix-rich-content-plugin-collapsible-list";
const initialExpandedItems = {
  FIRST: "FIRST",
  ALL: "ALL",
  NONE: "NONE"
};
const listDirection = {
  LTR: "LTR",
  RTL: "RTL"
};

export { COLLAPSIBLE_LIST_TYPE, initialExpandedItems, listDirection };
//# sourceMappingURL=types.js.map
